import { useState, useEffect } from "react";


import empty_user from "../../empty_user.png";

function WallReaded(props)
{

    const[tab,setTab] = useState(props.tab);
    const[view,setView] = useState("line");


    const changeView = () => {
        if(view == "line")  {setView("list");} else setView("line");
    }


    var persons = tab.length;


    if(view == "list")
    {
        return (
            <div className="item_info">
                <span  onClick={changeView}>Odczytało: {persons} -ukryj- </span>


               <div className="quickPopup shadowx">
                            <div className="item_info" style={{cursor:"pointer"}}  onClick={()=>{ setView("inline"); } }> - pokaż po przecinku - </div>                     
                            {  tab.map(  (item, ix) => {

                                    var defAwatar =           <img  src={empty_user} />
                                    if(item.awatar.length> 10) defAwatar=<img  src={ "data:image/jpeg;base64, " + item.awatar} />

                                    return <div className="qitem">
                                         {defAwatar}  {item.imie} {item.nazwisko} 
                                    </div>

                            } ) }
                   
                   <div><br/></div>                 
               </div>            

            </div> 
        )
       
    }

     if(view == "inline")
    {
        return (
            <div className="item_info">
              <span  onClick={changeView}>Odczytało: {persons} -ukryj- </span>

               <div style={{padding: '10px', backgroundColor:'#EFEFEF', borderRadius:"10px"}}>                      
                    Odczytali ({tab.length}): &nbsp;   
                            {  tab.map(  (item, ix) => {
                             
                                    return <span style={{color:'#000000'}}>
                                          {item.imie} {item.nazwisko}, &nbsp;
                                    </span>

                            } ) }
                   
  
               </div>
              

            </div> 
        )
       
    }


    return (
        <div className="item_info" onClick={changeView}>
              Odczytało: {persons} -pokaż-
        </div> 
    )
}


export default WallReaded;